import React from 'react';
import { VictoryPie } from "victory";
import _ from "lodash";
import styles from './DonutChart.module.scss';
import classNames from 'classnames';


const CenterText = ({ sum, totalUnits, description, totalClassName, totalStyle, descriptionClassName, descriptionStyle }) => {
    const total = `${sum} ${totalUnits ? totalUnits : ''}`;
    return <div className={[styles['center-text']]}>
        <div className={classNames(styles['total'], totalClassName, { [styles['fix-font']]: total.length >= 7 })} style={totalStyle}>{total}</div>
        <div className={classNames(styles['description'], descriptionClassName)} style={descriptionStyle}>{description ? description : ''}</div>
    </div>
};

/**
 * @deprecated: This is deprecated, please use DoughnutChart instead.
 */
const DonutChart = React.memo(({ className, padding, innerRadius: _innerRadius, noSumInnerRadius, radius: _radius, showTotal = true, data, totalUnits: _totalUnits, totalFormatter, description, colors, centerTextClass, totalClassName, totalStyle, descriptionClassName, descriptionStyle, mouseOverHandler, mouseOutHandler, padAngle = 0 }) => {

    let sum = _.sum(data);
    let totalUnits = _totalUnits;
    if (totalFormatter) {
        const { size, unit } = totalFormatter(sum);
        sum = _.parseInt(size);
        totalUnits = unit;
    }

    let innerRadius = sum ? 175 : 167;
    let radius = sum ? 143 : 170;

    if(!_.isUndefined(_radius)) {
        radius = _radius;
    }

    if (!_.isUndefined(_innerRadius)) {
        innerRadius = sum ? _innerRadius : noSumInnerRadius || _innerRadius;
    }

    return <div className={classNames(className, styles['doughnut'])}><VictoryPie
        padding={padding}
        innerRadius={innerRadius}
        radius={radius}
        labels={() => null}
        colorScale={sum ? colors : ["#979797"]}
        animate={{
            duration: 2000
        }}
        padAngle={padAngle}
        data={sum ? data : [1]}
        events={[{
            target: "data",
            eventHandlers: {
                onMouseOver: (e, props, index) => {
                    return [
                        {
                            target: "data",
                            mutation: function (props) {
                                return sum ? {
                                    style: {
                                        fill: props.style.fill,
                                        strokeWidth: 8,
                                        stroke: props.style.fill
                                    }
                                } : null
                            },
                            callback: () => (sum && (mouseOverHandler)) && mouseOverHandler(e, props, index)

                        }
                    ];
                },
                onMouseOut: (e, props, index) => {
                    return [
                        {
                            target: "data",
                            // eslint-disable-next-line @typescript-eslint/no-empty-function
                            mutation: () => {
                            },
                            callback: () => (sum && (mouseOutHandler)) && mouseOutHandler(e, props, index)

                        }
                    ];
                }
            }
        }]}
    />
        {showTotal &&
        <CenterText
            className={centerTextClass}
            sum={sum}
            totalUnits={totalUnits}
            description={description}
            totalClassName={totalClassName}
            totalStyle={totalStyle}
            descriptionClassName={descriptionClassName}
            descriptionStyle={descriptionStyle}
        />}
    </div>
});

export default DonutChart;

